module.exports = __webpack_public_path__ + "img/marc_h.a3d253b7.png";